import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
import { cn } from "@/lib/utils";
export const AlgoliaIcon = t0 => {
  const $ = _c(9);
  let className;
  let svg;
  if ($[0] !== t0) {
    ({
      className,
      ...svg
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = svg;
  } else {
    className = $[1];
    svg = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-12", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fill="#003dff" d="M63.998-.042C29.024-.042.511 28.16.006 63.015c-.512 35.402 28.208 64.734 63.613 64.94 10.934.063 21.465-2.612 30.817-7.693a1.5 1.5 0 0 0 .276-2.438l-5.987-5.309c-1.216-1.08-2.95-1.385-4.447-.747-6.528 2.777-13.622 4.195-20.93 4.106-28.608-.351-51.722-24.153-51.266-52.761.45-28.244 23.567-51.084 51.916-51.084h51.924v92.295l-29.46-26.176c-.952-.848-2.414-.681-3.182.335-4.728 6.262-12.431 10.155-20.987 9.564-11.868-.82-21.483-10.373-22.374-22.236-1.062-14.152 10.15-26.004 24.082-26.004 12.598 0 22.973 9.697 24.056 22.018a4.297 4.297 0 0 0 1.416 2.85l7.672 6.801c.87.77 2.253.3 2.465-.845.553-2.957.748-6.041.53-9.203-1.237-18.02-15.831-32.514-33.858-33.625-20.667-1.275-37.946 14.894-38.494 35.161-.535 19.75 15.647 36.776 35.399 37.212a36.028 36.028 0 0 0 22.067-6.904l38.492 34.122c1.651 1.462 4.255.292 4.255-1.915V2.39a2.434 2.434 0 0 0-2.432-2.43z" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== svg || $[7] !== t1) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" role="img" viewBox="0 0 128 128" className={t1} {...svg}>{t2}</svg>;
    $[6] = svg;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
AlgoliaIcon.displayName = "AlgoliaIcon";